"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferErrorHandler = exports.dappErrorHandler = void 0;
var errorRegex = /FailedTransactionError\(.*?error\s*=\s*(.*)?,\s*log/gm;
var dappErrorHandler = function (e, isKeeper) {
    var _a, _b;
    var data = (_a = e === null || e === void 0 ? void 0 : e.data) !== null && _a !== void 0 ? _a : e.message;
    if (typeof data === 'string' && (data === null || data === void 0 ? void 0 : data.includes('FailedTransactionError'))) {
        var errorMessage = (_b = errorRegex.exec(data)) === null || _b === void 0 ? void 0 : _b[1];
        if (errorMessage)
            return Promise.reject(new Error(errorMessage));
    }
    // if (e?.code == "1004" && !isKeeper) {
    //   return Promise.reject(signerErrors.authExpired)
    // }
    return Promise.reject(e);
};
exports.dappErrorHandler = dappErrorHandler;
var transferErrorHandler = function (e) {
    return Promise.reject(e);
};
exports.transferErrorHandler = transferErrorHandler;
//# sourceMappingURL=dappErorrs.js.map